// src/utils/CameraAngleLimitationConfig.js
export const CameraAngleLimitationConfig = {
    // 示例产品配置 3769
    "11": {
        // 水平旋转模式: "full" (360度旋转), "fixed" (固定不旋转), "limited" (限制角度)
        horizontalMode: "full",
        // 垂直旋转模式: "full" (正常转动), "fixed" (固定不转动), "limited" (限制角度)
        verticalMode: "limited",
        // 垂直角度限制 (仅在verticalMode为"limited"时有效，单位: 度)
        vertical: {
            min: -74.53,  // 垂直向下最大角度
            max: 74.53    // 垂直向上最大角度
        },
        // 水平角度限制 (仅在horizontalMode为"limited"时有效)
        horizontal: {
            min: -160,
            max: 160
        }
    },
    //TL-IPC44L4-WD23
    "3957": {
        horizontalMode: "limited",
        verticalMode: "limited",
        horizontal: {
            min: -160,
            max: 160
        },
        vertical: {
            min: -90,
            max: 15
        },
        focalLengthQiu: '4.8~110',
        focalLengthQiang: '2.8'
    },
    //TL-IPC6823TP-ADC
    "4007": {
        horizontalMode: "full",
        verticalMode: "limited",
        vertical: {
            min: -90,
            max: 15
        },
        focalLength:"4.8~110"
    },
    //TL-IPC689XD-A4
    "3886": {
        horizontalMode: "limited",
        verticalMode: "limited",
        horizontal: {
            min: -160,
            max: 160
        },
        vertical: {
            min: -90,
            max: 15
        },
        focalLengthQiu: '4',
        focalLengthQiang: '4'
    },
    //TL-IPC689X-A4GY
    "4015": {
        horizontalMode: "limited",
        verticalMode: "limited",
        horizontal: {
            min: -160,
            max: 160
        },
        vertical: {
            min: -90,
            max: 15
        },
        focalLengthQiu: '4',
        focalLengthQiang: '2.8'
    },
    //TL-IPC642X-A
    "3769": {
        horizontalMode: "limited",
        verticalMode: "limited",
        horizontal: {
            min: -160,
            max: 160
        },
        vertical: {
            min: -90,
            max: 15
            // max: 140.6
        },
        focalLength: "4"
    },
    //TL-IPC443ME-A 2.8云台版
    "2402": {
        horizontalMode: "limited",
        verticalMode: "limited",
        horizontal: {
            min: -160,
            max: 160
        },
        vertical: {
            min: -90,
            // max: 130.2
            max: 15
        },
        focalLength: "2.8"
    },
    //TL-NAIPC4453P-W
    "3398": {
        horizontalMode: "fixed",
        verticalMode: "fixed",
        focalLength: "2.8"
    },
    //TL-NAIPC5494P-MZ
    "2460": {
        horizontalMode: "fixed",
        verticalMode: "fixed",
        focalLength: "4.3~9.8"
    },
    //TL-NAIPC6467-W23
    "3667": {
        horizontalMode: "full",
        verticalMode: "limited",
        vertical: {
            min: -90,
            max: 35.6
        },
        focalLength: "4.8~110"
    },
    //TL-NAIPC4453P-Z
    "3910": {
        horizontalMode: "fixed",
        verticalMode: "fixed",
        focalLength: "2.7~12"
    },
    //TL-NAIPC4335P-S2.1
    "3722": {
        horizontalMode: "fixed",
        verticalMode: "fixed",
        focalLength: "2.1"
    },
    //TL-UC24
    "2818": {
        horizontalMode: "fixed",
        verticalMode: "fixed",
        focalLength: "3"
    },
    //TL-NAIPC5456P-I
    "3939": {
        horizontalMode: "fixed",
        verticalMode: "fixed",
        focalLength: "3"
    },
    //TL-NIPC1618-845A
    "3767": {
        horizontalMode: "full",
        verticalMode: "limited",
        vertical: {
            min: -90,
            max: 33
        },
        focalLengthQiu: '6.5~212',
        focalLengthQiang: '2.8'
    },
    //TL-NIPC5454P-A
    "3334": {
        horizontalMode: "fixed",
        verticalMode: "fixed",
        focalLength: "4"
    },
    //TL-NAIPC5454P-Z
    "3285": {
        horizontalMode: "fixed",
        verticalMode: "fixed",
        focalLength: "2.7~12"
    },
    //TL-NIPC4434P-4
    "4016": {
        horizontalMode: "limited",
        verticalMode: "limited",
        horizontal: {
            min: -160,
            max: 160
        },
        vertical: {
            min: -90,
            max: 15
            // max: 140.6
        },
        focalLength: "4"
    },
    //TL-IPC443MEP-AI
    "3525": {
        horizontalMode: "fixed",
        verticalMode: "fixed",
        focalLength: "2.8"
    },
    //TL-NIPC58A2P-WBP
    "2822": {
        horizontalMode: "fixed",
        verticalMode: "fixed",
        focalLength: "6mm+6"
    },
    //TL-NIPC846AP-A23
    "3839": {
        horizontalMode: "full",
        verticalMode: "limited",
        vertical: {
            min: -90,
            max: 15
        },
        focalLength:"4.8~110"
    },
    //TL-NIPC4484P-W4
    "4010": {
        horizontalMode: "fixed",
        verticalMode: "fixed",
        focalLength: "4"
    },
    //TL-NAIPC3531P-W
    "2990": {
        horizontalMode: "fixed",
        verticalMode: "fixed",
        focalLength: "2.8"
    },
    //TL-IPC548GP-W
    "3749": {
        horizontalMode: "fixed",
        verticalMode: "fixed",
        focalLength: "4"
    },
    //TL-NAIPC5484P-M4
    "2702": {
        horizontalMode: "fixed",
        verticalMode: "fixed",
        focalLength: "4"
    },
    //TL-IPC544ATP-WB
    "4169": {
        horizontalMode: "fixed",
        verticalMode: "fixed",
        focalLength: "4"
    },
    //TL-NAIPC689XP-A4GY
    "0": {
        horizontalMode: "limited",
        verticalMode: "limited",
        horizontal: {
            min: -160,
            max: 160
        },
        vertical: {
            min: -90,
            max: 2
        },
        focalLengthQiu: '3.52~10.33',
        focalLengthQiang: '4'
    },
    // 默认配置
    "default": {
        horizontalMode: "full",
        verticalMode: "full",
        vertical: {
            min: -90,
            max: 90
        },
        focalLength: "4"
    }
};